<template>
    <crud-facecade
     ref="slist"
        :url="url"
        :columns="columnList"
        :tableHeight="tableHeight"
        :buttons="[]"
        v-wechat-title="title"
        :addButton="{ enabled: true, permission: 'default' }"
        :deleteButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
    >
    <template #filter>
        <el-col :md="8" :lg="5" :xl="5">
            <item-input type="select"  v-model="isenabled" :options="is_enabled" clearable placeholder="状态"></item-input>
        </el-col>
    </template>
    </crud-facecade>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `DicSpecimen`,
    data() {
        return {
            title: `标本字典`,
            eventCategory: [],
            isenabled: false,
            url: {
                baseURL: `/api/Nursing/DicSpecimen`,
                get: paras => {
                    return new Promise(resolve => {
                        this.ReloadData().then(data => {
                            resolve(data)
                        })
                    })
                },
                put: row => {
                    return this.saveOne(row, `put`)
                }
            }
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`sys_enums`, `is_enabled`, `menu_icons`, `img_icons`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `ID`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    readonly: function(that, { row }) {
                        return row.id <= 0
                    },
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `标本名称`,
                    isListable: true,
                    isExpand: false,
                    sortable: true,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `rbool`,
                    prop: `is_deleted`,
                    label: `状态`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    sortable: true,
                    isCreatable: true,
                    readonly: false,
                    options: `is_enabled`,
                    default: false
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `60`,
                    fixed: `right`,
                    readonly: false,
                    isListable: true,
                    options: [
                        {
                            class: `is-plain`,
                            label: `编辑`,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `default` // user:assignRole
                        }
                    ]
                }
            ]
        }
    },
    methods: {
        ReloadData() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/DicSpecimen/Get`)
                req.then(data => {
                    let r = data
                    if (that.isenabled !== `` && that.isenabled !== null) {
                        r = _.filter(r, function(i) {
                            return i.is_deleted == that.isenabled
                        })
                    }
                    resolve(r)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        saveOne(row, type) {
            let data = { ...row }
            return new Promise((resolve, reject) => {
                let req = this.myaxios[type](`/api/Nursing/DicSpecimen/Put`, data)
                req.then(res => {
                    resolve(res)
                }).catch(e => reject(e))
            })
        }
    },
    watch: {
        isenabled: function() {
            this.$refs[`slist`].ReloadListData()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Specimen/Index.vue